import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { t } from '../../common/Translate';

const ModalGuaranteedPriceProcess = ({ isOpen, toggle, textBody, cancelGuaranteed, confirmGuaranteed }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal" size="md">
      <ModalBody className="pb-0">
        <div className="modal-guaranteed font-weight-bold">{textBody}</div>
        <div className="mt-5 text-center">
          <button type="button" className="btn btn-3 mr-3" onClick={cancelGuaranteed}>
            {t('cancel')}
          </button>
          <button type="button" className="btn btn-1" onClick={confirmGuaranteed}>
            {t('confirm')}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ModalGuaranteedPriceProcess.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  textBody: PropTypes.string.isRequired,
  cancelGuaranteed: PropTypes.string.isRequired,
  confirmGuaranteed: PropTypes.string.isRequired,
};
export default ModalGuaranteedPriceProcess;
